import React from "react";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "The most elegant med-spa experience in Michigan. My skin has never looked better, and the team makes every visit feel effortless.",
    author: "Jordan M.",
    meta: "Insider Member since 2024",
  },
  {
    quote:
      "This was the first time doing something for my skin. I came in before my daughter's wedding, and within 6 months I felt and looked like a new me! Everyone was shocked at my results — I can't thank the Iridescent Team enough.",
    author: "Barbara L.",
    meta: "Insider+ Member since 2025",
  },
  {
    quote:
      "Having been to a lot of spas before, I think I found my new place. From the consultation to the treatment, you can really see that everyone here cares about you and your results. I highly recommend giving it a try if you're looking for a new spa.",
    author: "Sara T.",
    meta: "Insider Member since 2025",
  },
  {
    quote:
      "After trying many treatments and not getting the results I wanted, Carmen gave me a plan for what I want to achieve. My treatments with Brooklyn have been amazing so far — definitely starting to see a change, just have to give it time.",
    author: "Mariana J.",
    meta: "Insider+ Member since 2023",
  },
];

function ReviewCard({ r }) {
  return (
    <figure className="shrink-0 w-[300px] sm:w-[380px] bg-white rounded-[1.5rem] border border-black/5 p-8 flex flex-col">
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="h-4 w-4 fill-iri-mid text-iri-mid" />
        ))}
      </div>
      <blockquote className="font-accent text-lg italic text-ink leading-relaxed flex-1">
        “{r.quote}”
      </blockquote>
      <figcaption className="mt-6 text-sm text-[#5C6664]">
        — {r.author}, <span className="text-[#8A9492]">{r.meta}</span>
      </figcaption>
    </figure>
  );
}

export function ReviewsMarquee() {
  const loop = [...REVIEWS, ...REVIEWS];
  return (
    <div className="marquee-mask marquee-pause overflow-hidden" data-testid="reviews-marquee">
      <div className="flex gap-6 w-max animate-marquee py-2">
        {loop.map((r, i) => (
          <ReviewCard key={i} r={r} />
        ))}
      </div>
    </div>
  );
}
